import { TacticTooltip } from '@/components/basic';
import { imageUrl } from '@/lib/utils';
import { IResourcePermission } from '@gettactic/api';
import { LockClosedIcon } from '@heroicons/react/outline';
import { UsersIcon } from '@heroicons/react/solid';
import React from 'react';
import { Column } from 'react-table';

type Props = {
  permission: IResourcePermission;
  column: Column<IResourcePermission>;
};

export default function PermissionCell({ permission, column }: Props) {
  const { user, team } = permission;
  return user ? (
    <div className="flex flex-nowrap items-center gap-4 border-l border-l-gray-300 py-4 pl-4"
      style={{
        maxWidth: column.maxWidth,
      }}>
      <div className="shrink-0">
        {user.profile_photo_url ? (
          <img
            className="h-10 w-10 rounded-full"
            src={imageUrl(user.profile_photo_url, '40x40_face')}
            alt="user"
          />
        ) : (
          <div className="relative flex h-10 w-10 items-center justify-center rounded-full bg-gray-600">
            <span className="text-base text-white">{user.name.charAt(0)}</span>
          </div>
        )}
      </div>
      <div className="flex flex-col flex-nowrap truncate text-wrap text-sm break-words">
        <h6 className="font-bold text-black">{user.name}</h6>
        <p className="font-normal text-tertiary" />
      </div>
    </div>
  ) : team ? (
    <div className="flex flex-nowrap items-center gap-4 border-l border-l-gray-300 py-4 pl-4">
      <div className="rounded-full bg-secondary-hover p-2">
        <UsersIcon className="h-4 w-4 text-white" />
      </div>
      <h6 className="text-sm font-bold text-tertiary text-wrap break-words">{team.name}</h6>
      {team.is_hidden ? (
        <TacticTooltip
          reference={
            <div className="flex items-center rounded-2xl bg-amber-50 px-2 text-xs text-amber-500">
              <LockClosedIcon className="h-4 w-4" />
            </div>
          }
          stateProps={{
            placement: 'top'
          }}
        >
          <p className="text-base text-amber-500">Hidden</p>
        </TacticTooltip>
      ) : null}
    </div>
  ) : null;
}
